import React from 'react'

export const Footer = () => {
    return (
        <div>
            <footer className="main-footer">
            <div className="float-right d-none d-sm-block">
                <b>Version</b> 1.0.0
            </div>
            <strong>Copyright © 2021 Muhammad Bayustira Hermadana Putra</strong>
            </footer>
        </div>
    )
}
